import { TestCaseTemplate } from "@/common/api.service"
import { FETCH_TEST_CASE_TEMPLATE_DATA, DOWNLOAD_TEST_CASE_TEMPLATE, FETCH_TEST_CASE_TEMPLATE_INDIVIDUAL_DATA, ADD_TEST_CASE_TEMPLATE_DATA, UPDATE_TEST_CASE_TEMPLATE_DATA, DELETE_TEST_CASE_TEMPLATE_DATA, RESET_STATE } from "./actions.type"
import { SET_TEST_CASE_TEMPLATE_DATA, SET_TEST_CASE_TEMPLATE_INDIVIDUAL_DATA, SET_ERROR_TEST_CASE_TEMPLATE_DATA, STATE_RESET  } from "./mutations.type"

const initialState = () => {
    return {
        testcasetemplatedata: [],
        individualtestcasetemplate: {},
        testcasetemplateerrors: null,
    }
}

let state = initialState()

const getters = {
    testcasetemplatedata(state) {
        return state.testcasetemplatedata
    },
    individualtestcasetemplate(state) {
        return state.individualtestcasetemplate
    }
}

const actions = {
    async [FETCH_TEST_CASE_TEMPLATE_DATA](context, slug) {
        const { data } = await TestCaseTemplate.get(slug)
        context.commit(SET_TEST_CASE_TEMPLATE_DATA, data.data)
        return data;
    },
    async [FETCH_TEST_CASE_TEMPLATE_INDIVIDUAL_DATA](context, slug) {
        const { data } = await TestCaseTemplate.get(slug)
        context.commit(SET_TEST_CASE_TEMPLATE_INDIVIDUAL_DATA, data.data)
        return data;
    },  
    async [ADD_TEST_CASE_TEMPLATE_DATA](context, payload) {
        return await TestCaseTemplate.create(payload, '')
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_TEST_CASE_TEMPLATE_DATA, error.response.data.errors)
        });
    },   
    async [DOWNLOAD_TEST_CASE_TEMPLATE](context, payload) {
        return await TestCaseTemplate.get(payload)
          .then(({data}) => {
            return data
          })
          .catch(error => {
            context.commit(SET_ERROR_TEST_CASE_TEMPLATE_DATA, (error.response.data.hasOwnProperty('errors') ? error.response.data.errors : error.response.data.message));
          });
    },    
    async [UPDATE_TEST_CASE_TEMPLATE_DATA](context, payload) {
        return await TestCaseTemplate.update(payload, (payload.get('temp_id')?payload.get('temp_id'):'' ))
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_TEST_CASE_TEMPLATE_DATA, error.response.data.errors)
        });
    },  
    async [DELETE_TEST_CASE_TEMPLATE_DATA] (context, id) {
        return await TestCaseTemplate.delete(id)
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_TEST_CASE_TEMPLATE_DATA, error.response.data.errors)
        });
    },    
    [RESET_STATE]({ commit }) {
        commit(STATE_RESET);
    }
}

const mutations = {
    [SET_ERROR_TEST_CASE_TEMPLATE_DATA](state, error) {
        state.testcasetemplateerrors = error
    },      
    [SET_TEST_CASE_TEMPLATE_DATA](state, testcasetemplatedata) {
        state.testcasetemplatedata = testcasetemplatedata
    },
    [SET_TEST_CASE_TEMPLATE_INDIVIDUAL_DATA](state, individualtestcasetemplate) {
        state.individualtestcasetemplate = individualtestcasetemplate
    },    
    [STATE_RESET](state) {
        Object.assign(state, initialState())
    } 
};

export default {
    state,
    getters,
    actions,
    mutations
};